import { render, staticRenderFns } from "./CommonCardPageList.vue?vue&type=template&id=0156de33&scoped=true&"
import script from "./CommonCardPageList.vue?vue&type=script&lang=js&"
export * from "./CommonCardPageList.vue?vue&type=script&lang=js&"
import style0 from "./CommonCardPageList.vue?vue&type=style&index=0&id=0156de33&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156de33",
  null
  
)

export default component.exports